/**
 * Capacity Product Page JavaScript
 * Handles: Swiper gallery, variant card selection, sticky bar, comparison table
 */
(function () {
  'use strict';

  /* =============================================
     Scroll Animations — Intersection Observer
     ============================================= */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('.capacity-feature__text');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('capacity-feature__text--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* =============================================
     Variant Card Selector — Multi-Select Toggle
     ============================================= */
  function initVariantCards() {
    var cards = document.querySelectorAll('.capacity-hero__variant-card');
    if (!cards.length) return;

    var priceCurrent = document.querySelector('.capacity-hero__price-current');
    var priceCompare = document.querySelector('.capacity-hero__price-compare');
    var discountBadge = document.querySelector('.capacity-hero__discount-badge');
    var btnAdd = document.querySelector('.capacity-hero__btn-add');
    var variantInput = document.querySelector('.capacity-hero__variant-input');
    var stickyImage = document.querySelector('.capacity-sticky-bar__image');
    var stickyPrice = document.querySelector('.capacity-sticky-bar__price');
    var stickyBtn = document.querySelector('.capacity-sticky-bar__btn');

    // Toggle card selected state (multi-select)
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        // Ignore clicks on qty controls
        if (event.target.closest('.capacity-hero__variant-card-qty')) return;
        if (card.classList.contains('capacity-hero__variant-card--unavailable')) return;

        card.classList.toggle('capacity-hero__variant-card--active');

        // Update hidden variant input to first selected card
        var firstSelected = document.querySelector('.capacity-hero__variant-card--active');
        if (variantInput && firstSelected) {
          variantInput.value = firstSelected.getAttribute('data-variant-id');
        }

        // Update URL to first selected variant
        if (firstSelected) {
          var url = new URL(window.location);
          url.searchParams.set('variant', firstSelected.getAttribute('data-variant-id'));
          window.history.replaceState({}, '', url);
        }

        // Update carousel to first selected variant's slide
        var swiper = window.capacityHeroMainSwiper;
        if (swiper && firstSelected) {
          var slideIdx = parseInt(firstSelected.getAttribute('data-variant-slide'));
          if (!isNaN(slideIdx) && slideIdx >= 0 && slideIdx < swiper.total) {
            swiper.slideTo(slideIdx);
          }
        }

        // Update highlights from first selected card
        if (firstSelected) {
          var highlightsList = document.getElementById('capacity-hero-highlights-list');
          if (highlightsList) {
            var highlightsData = firstSelected.getAttribute('data-highlights');
            if (highlightsData) {
              var items = highlightsData.split(',');
              highlightsList.innerHTML = items.map(function(h) { return '<p>' + h.trim() + '</p>'; }).join('');
            }
          }
        }

        // Update sticky bar to first selected variant
        if (stickyImage) {
          var heroImg = document.querySelector('.capacity-hero__slide-img');
          if (heroImg) stickyImage.src = heroImg.src;
        }

        // Recalculate prices and summary
        updateVariantPrices();
        updateSelectionSummary();
        updateAddToCartButton();
      });

      // Keyboard support for div[role=button]
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    // Quantity selector controls
    document.querySelectorAll('.capacity-hero__variant-card-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var qty = btn.closest('.capacity-hero__variant-card-qty');
        if (!qty) return;
        var input = qty.querySelector('.capacity-hero__variant-card-qty-input');
        if (!input) return;
        var val = parseInt(input.value) || 1;
        var card = qty.closest('.capacity-hero__variant-card');
        if (btn.getAttribute('data-action') === 'minus') {
          if (val <= 1 && card) {
            // Deselect the card
            card.classList.remove('capacity-hero__variant-card--active');
            input.value = 1;
            updateVariantPrices();
            updateSelectionSummary();
            updateAddToCartButton();
            return;
          }
          val = val - 1;
        } else {
          val = Math.min(999, val + 1);
        }
        input.value = val;
        updateVariantPrices();
        updateSelectionSummary();
        updateAddToCartButton();
      });
    });

    // Manual input: select all on focus, validate on blur
    document.querySelectorAll('.capacity-hero__variant-card-qty-input').forEach(function (input) {
      input.addEventListener('focus', function () { input.select(); });
      input.addEventListener('blur', function () {
        var val = parseInt(input.value) || 1;
        val = Math.max(1, Math.min(999, val));
        input.value = val;
        updateVariantPrices();
        updateSelectionSummary();
        updateAddToCartButton();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });
    });
  }

  /* =============================================
     Update Variant Prices (multi-select total)
     ============================================= */
  function updateVariantPrices() {
    var priceCurrent = document.querySelector('.capacity-hero__price-current');
    var priceCompare = document.querySelector('.capacity-hero__price-compare');
    var discountBadge = document.querySelector('.capacity-hero__discount-badge');
    if (!priceCurrent) return;

    var selected = document.querySelectorAll('.capacity-hero__variant-card--active');
    var totalSale = 0;
    var totalCompare = 0;

    selected.forEach(function (card) {
      var priceText = card.getAttribute('data-variant-price') || '';
      var compareText = card.getAttribute('data-variant-compare-price') || '';
      var qtyInput = card.querySelector('.capacity-hero__variant-card-qty-input');
      var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

      var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      var compare = compareText ? (parseFloat(compareText.replace(/[^0-9.]/g, '')) || 0) : 0;

      totalSale += price * qty;
      totalCompare += compare * qty;
    });

    if (selected.length === 0) {
      // No selection: show default variant
      var defaultCard = document.querySelector('.capacity-hero__variant-card');
      if (defaultCard) {
        totalSale = parseFloat(defaultCard.getAttribute('data-variant-price').replace(/[^0-9.]/g, '')) || 0;
        totalCompare = parseFloat((defaultCard.getAttribute('data-variant-compare-price') || '').replace(/[^0-9.]/g, '')) || 0;
      }
    }

    var formattedSale = '$' + totalSale.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    priceCurrent.textContent = formattedSale;

    if (priceCompare) {
      if (totalCompare > totalSale) {
        var formattedCompare = '$' + totalCompare.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        priceCompare.textContent = formattedCompare;
        priceCompare.style.display = 'inline';
      } else {
        priceCompare.style.display = 'none';
      }
    }

    if (discountBadge) {
      if (totalCompare > totalSale) {
        var pct = Math.round((1 - totalSale / totalCompare) * 100);
        discountBadge.textContent = pct + '% OFF';
        discountBadge.style.display = 'inline-block';
      } else {
        discountBadge.style.display = 'none';
      }
    }

    // Update sticky bar price
    var stickyPrice = document.querySelector('.capacity-sticky-bar__price');
    if (stickyPrice) stickyPrice.textContent = formattedSale;
  }

  /* =============================================
     Selection Summary (count + total)
     ============================================= */
  function updateSelectionSummary() {
    var summary = document.querySelector('.capacity-hero__summary');
    var summaryText = document.querySelector('.capacity-hero__summary-text');
    if (!summary || !summaryText) return;

    var selected = document.querySelectorAll('.capacity-hero__variant-card--active');
    if (selected.length === 0) {
      summary.hidden = true;
      return;
    }

    var totalCount = 0;
    var totalPrice = 0;

    selected.forEach(function (card) {
      var priceText = card.getAttribute('data-variant-price') || '';
      var qtyInput = card.querySelector('.capacity-hero__variant-card-qty-input');
      var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
      var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      totalCount += qty;
      totalPrice += price * qty;
    });

    var formatted = '$' + totalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    summaryText.textContent = totalCount + ' selected, total ' + formatted;
    summary.hidden = false;
  }

  /* =============================================
     Update Add to Cart Button State
     ============================================= */
  function updateAddToCartButton() {
    var btnAdd = document.querySelector('.capacity-hero__btn-add');
    var stickyBtn = document.querySelector('.capacity-sticky-bar__btn');
    if (!btnAdd) return;

    var selected = document.querySelectorAll('.capacity-hero__variant-card--active');
    var hasAvailable = false;

    selected.forEach(function (card) {
      if (card.getAttribute('data-variant-available') === 'true') hasAvailable = true;
    });

    if (selected.length === 0 || !hasAvailable) {
      btnAdd.disabled = true;
      if (selected.length === 0) btnAdd.textContent = 'Select a Variant';
      else btnAdd.textContent = 'Sold Out';
    } else {
      btnAdd.disabled = false;
      btnAdd.textContent = 'Add to Cart';
    }

    if (stickyBtn) {
      stickyBtn.disabled = btnAdd.disabled;
      stickyBtn.textContent = btnAdd.textContent;
    }
  }

  /* =============================================
     Comparison Table Select Buttons
     ============================================= */
  function initSpecTable() {
    var selectBtns = document.querySelectorAll('.capacity-specs__select-btn:not(.capacity-specs__select-btn--current)');
    selectBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = this.getAttribute('data-variant-id');
        var card = document.querySelector('.capacity-hero__variant-card[data-variant-id="' + variantId + '"]');
        if (card) {
          card.click();
          var hero = document.querySelector('.capacity-hero');
          if (hero) {
            hero.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  }

  /* =============================================
     Sticky Add-to-Cart Bar
     ============================================= */
  function initStickyBar() {
    var hero = document.querySelector('.capacity-hero');
    var stickyBar = document.querySelector('.capacity-sticky-bar');
    if (!hero || !stickyBar) return;

    var stickyQty = stickyBar.querySelector('.capacity-sticky-bar__qty-input');
    var stickyMinus = stickyBar.querySelector('.capacity-sticky-bar__qty-btn--minus');
    var stickyPlus = stickyBar.querySelector('.capacity-sticky-bar__qty-btn--plus');
    var stickyBtn = stickyBar.querySelector('.capacity-sticky-bar__btn');
    var heroQty = document.querySelector('.capacity-hero__qty-input');
    var heroBtn = document.querySelector('.capacity-hero__btn-add');

    function updateVisibility() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        stickyBar.classList.add('capacity-sticky-bar--visible');
      } else {
        stickyBar.classList.remove('capacity-sticky-bar--visible');
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    if (stickyMinus && stickyPlus && stickyQty) {
      stickyMinus.addEventListener('click', function () {
        var val = parseInt(stickyQty.value) || 1;
        if (val > 1) stickyQty.value = val - 1;
      });

      stickyPlus.addEventListener('click', function () {
        var val = parseInt(stickyQty.value) || 1;
        stickyQty.value = val + 1;
      });
    }
  }

  /* =============================================
     Init All
     ============================================= */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollAnimations();
      initVariantCards();
      initSpecTable();
      initStickyBar();
      initComboCompare();
      initAccessories();
      initAddToCartWithAccessories();
    });
  } else {
    initScrollAnimations();
    initVariantCards();
    initSpecTable();
    initStickyBar();
    initComboCompare();
    initAccessories();
    initAddToCartWithAccessories();
  }

  /* =============================================
     Combo Comparison Table Dialog
     ============================================= */
  function initComboCompare() {
    var toggle = document.querySelector('.capacity-hero__compare-toggle');
    var dialog = document.querySelector('.capacity-hero__compare-dialog');
    if (!toggle || !dialog) return;

    var closeBtn = dialog.querySelector('.capacity-hero__compare-dialog-close');
    var scroll = dialog.querySelector('.capacity-hero__compare-scroll');

    function fitScroll() {
      if (!scroll) return;
      var header = dialog.querySelector('.capacity-hero__compare-dialog-header');
      var headerH = header ? header.offsetHeight : 0;
      var maxH = Math.floor(window.innerHeight * 0.85) - headerH;
      scroll.style.maxHeight = maxH + 'px';
    }

    toggle.addEventListener('click', function () {
      dialog.showModal();
      requestAnimationFrame(fitScroll);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('click', function (e) {
      var btn = e.target.closest('.capacity-hero__compare-add-btn');
      if (!btn || btn.disabled) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          setTimeout(function () { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
    });

    window.addEventListener('resize', function () {
      if (dialog.open) fitScroll();
    });
  }

  /* =============================================
     Accessories — Checkbox, Qty, Details
     ============================================= */
  function initAccessories() {
    var items = document.querySelectorAll('.capacity-hero__accessory-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var checkbox = item.querySelector('.capacity-hero__accessory-checkbox');
      var qtyWrap = item.querySelector('.capacity-hero__accessory-qty');
      var minusBtn = item.querySelector('.capacity-hero__accessory-qty--minus');
      var plusBtn = item.querySelector('.capacity-hero__accessory-qty--plus');
      var qtyInput = item.querySelector('.capacity-hero__accessory-qty-input');

      // Toggle selection
      if (checkbox) {
        checkbox.addEventListener('click', function () {
          var selected = item.classList.toggle('capacity-hero__accessory-item--selected');
          if (qtyWrap) qtyWrap.hidden = !selected;
          if (qtyInput && selected) qtyInput.value = 1;
          updateTotalPrice();
        });
      }

      // Decrease qty
      if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value) || 1;
          if (val > 1) { qtyInput.value = val - 1; updateTotalPrice(); }
        });
      }

      // Increase qty
      if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value) || 1;
          if (val < 50) { qtyInput.value = val + 1; updateTotalPrice(); }
        });
      }

      // Details toggle
      var detailsToggle = item.querySelector('.capacity-hero__accessory-details-toggle');
      var detailsBody = item.querySelector('.capacity-hero__accessory-details-body');
      if (detailsToggle && detailsBody) {
        detailsToggle.addEventListener('click', function () {
          var hidden = detailsBody.hidden;
          detailsBody.hidden = !hidden;
          detailsToggle.setAttribute('aria-expanded', !hidden);
          var chevron = detailsToggle.querySelector('.capacity-hero__accessory-details-chevron');
          if (chevron) chevron.style.transform = hidden ? 'rotate(180deg)' : 'rotate(0)';
        });
      }
    });
  }

  /* =============================================
     Update Total Price (all selected variants + accessories)
     ============================================= */
  function updateTotalPrice() {
    updateVariantPrices();
    updateSelectionSummary();
    updateAddToCartButton();
  }

  /* =============================================
     Add to Cart — All selected variants + accessories
     ============================================= */
  function initAddToCartWithAccessories() {
    var btnAdd = document.querySelector('.capacity-hero__btn-add');
    var stickyBtn = document.querySelector('.capacity-sticky-bar__btn');
    if (!btnAdd) return;

    function handleAddToCart(e) {
      e.preventDefault();

      var selected = document.querySelectorAll('.capacity-hero__variant-card--active');
      if (!selected.length) return;

      var items = [];

      // All selected variants with their quantities
      selected.forEach(function (card) {
        var variantId = parseInt(card.getAttribute('data-variant-id'));
        var qtyInput = card.querySelector('.capacity-hero__variant-card-qty-input');
        var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
        if (card.getAttribute('data-variant-available') === 'true' && variantId) {
          items.push({ id: variantId, quantity: qty });
        }
      });

      // Selected accessories
      var accessoryItems = document.querySelectorAll('.capacity-hero__accessory-item--selected');
      accessoryItems.forEach(function (item) {
        var variantId = parseInt(item.getAttribute('data-variant-id'));
        var qtyInput = item.querySelector('.capacity-hero__accessory-qty-input');
        var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
        if (variantId) {
          items.push({ id: variantId, quantity: qty });
        }
      });

      if (!items.length) return;

      var originalText = btnAdd.textContent;
      btnAdd.disabled = true;
      btnAdd.textContent = 'Adding...';

      // Queue all items to cart
      var promises = items.map(function (item) {
        var data = new FormData();
        data.append('id', item.id);
        data.append('quantity', item.quantity);
        data.append('sections', 'cart-drawer');
        return fetch('/cart/add.js', { method: 'POST', body: data });
      });

      Promise.all(promises)
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          console.error('[CapacityHero] Add to cart failed:', err);
          btnAdd.disabled = false;
          btnAdd.textContent = originalText;
          alert('Failed to add items to cart. Please try again.');
        });
    }

    btnAdd.addEventListener('click', handleAddToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', handleAddToCart);
  }
})();
